import { render, staticRenderFns } from "./IconArrowShare.vue?vue&type=template&id=629dae2b&"
import script from "./IconArrowShare.vue?vue&type=script&lang=js&"
export * from "./IconArrowShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports